import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-266e5df9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "inline-grid" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Add Cards", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Rearrange Cards", -1))
const _hoisted_5 = { class: "vertical" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "card--divider" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IonLabel = _resolveComponent("IonLabel")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_IonItem = _resolveComponent("IonItem")!
  const _component_IonInput = _resolveComponent("IonInput")!
  const _component_IonIcon = _resolveComponent("IonIcon")!
  const _component_IonChip = _resolveComponent("IonChip")!
  const _component_SelfDestructImage = _resolveComponent("SelfDestructImage")!
  const _component_IonThumbnail = _resolveComponent("IonThumbnail")!
  const _component_IonButton = _resolveComponent("IonButton")!
  const _component_IonToggle = _resolveComponent("IonToggle")!
  const _component_AddFlashcardsToDeck = _resolveComponent("AddFlashcardsToDeck")!
  const _component_ReorderFlashcardsInDeck = _resolveComponent("ReorderFlashcardsInDeck")!
  const _component_SelectImage = _resolveComponent("SelectImage")!
  const _component_AsyncButton = _resolveComponent("AsyncButton")!
  const _component_ModalPattern = _resolveComponent("ModalPattern")!

  return (_openBlock(), _createBlock(_component_ModalPattern, {
    title: _ctx.deckId === undefined ? 'Make a new deck' : 'Edit a deck',
    dismiss: _ctx.dismiss
  }, {
    default: _withCtx(() => [
      (_ctx.view === 'Main')
        ? (_openBlock(), _createElementBlock("form", _hoisted_1, [
            _createVNode(_component_IonItem, null, {
              default: _withCtx(() => [
                _createVNode(_component_IonLabel, { class: "input" }, {
                  default: _withCtx(() => [
                    _createTextVNode("Title")
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_input, {
                  modelValue: _ctx.deckBeingEdited.title,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.deckBeingEdited.title) = $event)),
                  type: "text"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_IonItem, null, {
              default: _withCtx(() => [
                _createVNode(_component_IonLabel, { class: "input" }, {
                  default: _withCtx(() => [
                    _createTextVNode("Tags")
                  ]),
                  _: 1
                }),
                _createVNode(_component_IonInput, {
                  id: "tagInput",
                  modelValue: _ctx.tag,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.tag) = $event)),
                  type: "text",
                  onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (_ctx.addTag()), ["enter"]))
                }, null, 8, ["modelValue"]),
                _createVNode(_component_IonIcon, {
                  icon: _ctx.addCircle,
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.addTag()))
                }, null, 8, ["icon"])
              ]),
              _: 1
            }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.deckBeingEdited.tags, (tag) => {
              return (_openBlock(), _createBlock(_component_IonChip, { key: tag }, {
                default: _withCtx(() => [
                  _createVNode(_component_IonLabel, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(tag), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_IonIcon, {
                    onClick: ($event: any) => (_ctx.removeTag(tag)),
                    icon: _ctx.closeCircle
                  }, null, 8, ["onClick", "icon"])
                ]),
                _: 2
              }, 1024))
            }), 128)),
            _createVNode(_component_IonItem, null, {
              default: _withCtx(() => [
                _createVNode(_component_IonLabel, null, {
                  default: _withCtx(() => [
                    _createTextVNode("Image")
                  ]),
                  _: 1
                }),
                (_ctx.displayPic)
                  ? (_openBlock(), _createBlock(_component_IonThumbnail, {
                      key: 0,
                      "item-start": ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_SelfDestructImage, { src: _ctx.displayPic }, null, 8, ["src"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.deckBeingEdited.img?.length)
                  ? (_openBlock(), _createBlock(_component_IonIcon, {
                      key: 1,
                      onClick: _ctx.clearImage,
                      class: "clear-image",
                      icon: _ctx.closeCircle
                    }, null, 8, ["onClick", "icon"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_IonButton, {
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.openImageSelector())),
                  color: "secondary",
                  fill: "outline"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_IonIcon, { icon: _ctx.image }, null, 8, ["icon"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_IonItem, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("p", null, _toDisplayString(_ctx.numCards), 1),
                  _createVNode(_component_IonButton, {
                    color: "primary",
                    fill: "outline",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.openCardSelector()))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_3,
                      _createVNode(_component_IonIcon, { icon: _ctx.add }, null, 8, ["icon"])
                    ]),
                    _: 1
                  }),
                  (_ctx.numCards)
                    ? (_openBlock(), _createBlock(_component_IonButton, {
                        key: 0,
                        color: "secondary",
                        fill: "outline",
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.openCardArranger()))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_4,
                          _createElementVNode("span", _hoisted_5, [
                            _createVNode(_component_IonIcon, { icon: _ctx.repeatSharp }, null, 8, ["icon"])
                          ])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_IonItem, null, {
              default: _withCtx(() => [
                _createVNode(_component_IonToggle, {
                  "aria-label": "Public",
                  modelValue: _ctx.deckBeingEdited.public,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.deckBeingEdited.public) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]))
        : (_ctx.view === 'AddFlashcardsToDeck')
          ? (_openBlock(), _createBlock(_component_AddFlashcardsToDeck, _normalizeProps(_mergeProps({ key: 1 }, _ctx.addFlashcardsToDeckProps)), null, 16))
          : (_ctx.view === 'ReorderFlashcardsInDeck')
            ? (_openBlock(), _createBlock(_component_ReorderFlashcardsInDeck, _normalizeProps(_mergeProps({ key: 2 }, _ctx.reorderFlashcardsInDeckProps)), null, 16))
            : _createCommentVNode("", true),
      (_ctx.view === 'SelectImage')
        ? (_openBlock(), _createBlock(_component_SelectImage, _normalizeProps(_mergeProps({ key: 3 }, _ctx.selectImageProps)), null, 16))
        : _createCommentVNode("", true),
      _hoisted_6,
      _createVNode(_component_AsyncButton, {
        class: "max-width center",
        disabled: !_ctx.isValid,
        id: "save",
        "ion-button": "",
        "icon-end": "",
        block: "",
        asyncFn: _ctx.upload
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Save ")
        ]),
        _: 1
      }, 8, ["disabled", "asyncFn"])
    ]),
    _: 1
  }, 8, ["title", "dismiss"]))
}